import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
const InitPage = ({ children, title }) => {
    // 设置标题
    document.title = title;
    useEffect(() => { }, []);
    return _jsx(_Fragment, { children: children });
};
export default InitPage;
